module.exports = __webpack_public_path__ + "static/media/climbing_view_768.8a280f42.jpg";